(() => {
  const CACHE_KEY = 'frizi-boutique-best-sellers-v1';
  const EYE_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"></path><circle cx="12" cy="12" r="2.5" fill="none" stroke="currentColor" stroke-width="1.8"></circle></svg>';

  const shuffle = (items) => {
    const result = [...items];
    for (let index = result.length - 1; index > 0; index -= 1) {
      const nextIndex = Math.floor(Math.random() * (index + 1));
      [result[index], result[nextIndex]] = [result[nextIndex], result[index]];
    }
    return result;
  };

  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
    style: 'currency', currency: 'EUR'
  }).format(cents / 100);

  const init = () => {
    const grid = document.querySelector('[data-frizi-boutique-grid]');
    const rail = document.querySelector('[data-frizi-filter-rail]');
    if (!grid || !rail || !Array.isArray(window.FRIZI_BEST_SELLERS)) return;

    const previous = document.querySelector('[data-frizi-filter-prev]');
    const next = document.querySelector('[data-frizi-filter-next]');
    const lightbox = document.querySelector('[data-frizi-boutique-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-frizi-boutique-lightbox-image]');
    const lightboxTitle = lightbox?.querySelector('[data-frizi-boutique-lightbox-title]');
    let initialCards = Array.from(grid.children);

    const updateArrows = () => {
      const maxScrollLeft = rail.scrollWidth - rail.clientWidth;
      const noOverflow = maxScrollLeft <= 4;
      previous.hidden = noOverflow || rail.scrollLeft <= 4;
      next.hidden = noOverflow || rail.scrollLeft >= maxScrollLeft - 4;
    };

    previous?.addEventListener('click', () => rail.scrollBy({ left: -Math.max(rail.clientWidth * 0.75, 160), behavior: 'smooth' }));
    next?.addEventListener('click', () => rail.scrollBy({ left: Math.max(rail.clientWidth * 0.75, 160), behavior: 'smooth' }));
    rail.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    requestAnimationFrame(updateArrows);

    const closeLightbox = () => { if (lightbox) lightbox.hidden = true; };
    const openLightbox = (src, title) => {
      if (!lightbox || !lightboxImage || !src) return;
      lightboxImage.src = src;
      lightboxImage.alt = title || '';
      if (lightboxTitle) lightboxTitle.textContent = title || '';
      lightbox.hidden = false;
      lightbox.querySelector('.frizi-boutique-lightbox__close')?.focus();
    };
    lightbox?.querySelectorAll('[data-frizi-boutique-lightbox-close]').forEach((button) => button.addEventListener('click', closeLightbox));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeLightbox(); });

    const decorateCards = (scope = grid) => {
      scope.querySelectorAll('.card--product').forEach((card) => {
        const media = card.querySelector('.card__image');
        if (!media || media.querySelector('.frizi-boutique-preview')) return;
        const image = media.querySelector('img');
        const title = card.querySelector('.card__title')?.textContent.trim() || image?.alt || 'ce produit';
        if (!image?.currentSrc && !image?.src) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'frizi-boutique-preview';
        button.setAttribute('aria-label', `Prévisualiser ${title}`);
        button.innerHTML = EYE_ICON;
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          openLightbox(image.currentSrc || image.src, title);
        });
        media.append(button);
      });
    };

    const fetchProducts = async () => {
      try {
        const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
        if (Array.isArray(cached) && cached.length) return cached;
      } catch (_) {}
      const products = await Promise.all(window.FRIZI_BEST_SELLERS.map(async (handle) => {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        if (!response.ok) return null;
        return response.json();
      }));
      const validProducts = products.filter(Boolean);
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(validProducts)); } catch (_) {}
      return validProducts;
    };

    const updateClone = (card, product) => {
      const productUrl = product.url || `/products/${product.handle}`;
      card.querySelectorAll('.card__badge, .frizi-product-badges--card').forEach((node) => node.remove());
      card.querySelectorAll('a').forEach((link) => { link.href = productUrl; });
      card.querySelectorAll('img').forEach((image) => {
        image.src = product.featured_image;
        image.removeAttribute('srcset');
        image.alt = product.title;
      });
      const title = card.querySelector('.card__title');
      if (title) title.textContent = product.title;
      card.querySelectorAll('.price-item--regular, .price-item--sale').forEach((price) => { price.textContent = formatMoney(product.price); });
      card.querySelectorAll('.frizi-boutique-preview').forEach((button) => button.remove());
      return card;
    };

    const showBestSellers = async () => {
      rail.querySelectorAll('[data-quick-tag]').forEach((tag) => tag.classList.toggle('is-active', tag.hasAttribute('data-quick-tag-all')));
      grid.setAttribute('aria-busy', 'true');
      const products = shuffle(await fetchProducts());
      const blueprint = initialCards.find((card) => card.classList.contains('card--product'));
      if (!blueprint) return;
      grid.replaceChildren(...products.map((product) => updateClone(blueprint.cloneNode(true), product)));
      grid.setAttribute('aria-busy', 'false');
      decorateCards();
    };

    decorateCards();
    rail.querySelector('[data-quick-tag-all]')?.addEventListener('click', (event) => {
      event.preventDefault();
      showBestSellers();
    });

    if (rail.querySelector('[data-quick-tag-all]')?.classList.contains('is-active')) showBestSellers();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
